var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 50,
    viewBox: "0 0 63 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.4375 43.75H62.9375V50H0.4375V43.75ZM6.6875 0H16.0625V40.625H6.6875V0ZM19.1875 3.125H28.5625V40.625H19.1875V3.125ZM42.7618 5.41292L51.9944 3.78497L59.0181 40.625L48.8714 40.6792L42.7618 5.41292ZM31.6875 3.125H41.0625V40.625H31.6875V3.125Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.d20ce21ef324e72807b240fc4e6cb054.svg";
export { ForwardRef as ReactComponent };